<template>
  <header class="bg-white border-b border-gray-200 sticky top-0 z-50">
    <nav class="container-width px-4 md:px-8 lg:px-16">
      <div class="flex items-center justify-between h-20">
        <!-- Logo -->
        <NuxtLink to="/" class="flex items-center space-x-3">
          <div class="w-10 h-10 bg-primary-500 rounded-lg flex items-center justify-center">
            <span class="text-white font-bold text-xl">ER</span>
          </div>
          <span class="font-bold text-xl text-dark-900 hidden sm:block">Enrico Reinsdorf</span>
        </NuxtLink>

        <!-- Desktop Navigation -->
        <div class="hidden md:flex items-center space-x-8">
          <NuxtLink
            v-for="item in navigation"
            :key="item.to"
            :to="item.to"
            class="text-dark-700 hover:text-primary-500 transition-colors font-medium"
            active-class="text-primary-500"
          >
            {{ item.label }}
          </NuxtLink>
        </div>

        <!-- Mobile Menu Button -->
        <button
          @click="mobileMenuOpen = !mobileMenuOpen"
          class="md:hidden p-2 text-dark-700 hover:text-primary-500"
          aria-label="Toggle menu"
        >
          <svg v-if="!mobileMenuOpen" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
          <svg v-else class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Mobile Navigation -->
      <div
        v-if="mobileMenuOpen"
        class="md:hidden py-4 border-t border-gray-200"
      >
        <NuxtLink
          v-for="item in navigation"
          :key="item.to"
          :to="item.to"
          @click="mobileMenuOpen = false"
          class="block py-3 text-dark-700 hover:text-primary-500 transition-colors font-medium"
          active-class="text-primary-500"
        >
          {{ item.label }}
        </NuxtLink>
      </div>
    </nav>
  </header>
</template>

<script setup lang="ts">
const mobileMenuOpen = ref(false)

const navigation = [
  { label: 'Home', to: '/' },
  { label: 'Expertise', to: '/expertise' },
  { label: 'Portfolio', to: '/portfolio' },
  { label: 'Artikel', to: '/articles' },
  { label: 'Werdegang', to: '/career' },
  { label: 'Kontakt', to: '/contact' }
]

// Close mobile menu on route change
const route = useRoute()
watch(() => route.path, () => {
  mobileMenuOpen.value = false
})
</script>
